import { copyToDisco } from '@disco/state-management/actions/ExplorerActions'
import { getGroupsWithNesting } from '@disco/state-management/selectors/groups'
import { getPlaylist } from '@disco/state-management/selectors/playlists'

import React from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useParams, useNavigate } from 'react-router-dom'
import type { GroupId } from 'types/group'
import type { PlaylistId } from 'types/playlist'
import AddToChannelModal from 'components/common/custom-libraries/add-to-channel'
import DocumentHeadTags from 'components/document-head-tags'

const CopyToChannel = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams<{ playlistId: string; originGroupId: string }>()

  const playlistId = params.playlistId || ''
  const originGroupId = params.originGroupId || ''
  const groups = useSelector(getGroupsWithNesting)
  const playlist = useSelector(state =>
    getPlaylist(state, {
      id: parseInt(playlistId),
    }),
  )

  const handleClose = () => navigate('/')

  const handleAddToGroup = (
    groupsToAdd: Array<{ value: GroupId; label: string }>,
  ) => {
    const objectUrl = playlist?.view_playlist_url
    const groupIds = groupsToAdd.map(groupToAdd => groupToAdd.value)
    dispatch(
      copyToDisco(
        playlist?.name ?? '',
        objectUrl ?? '',
        {
          groupIds,
        },
        parseInt(originGroupId),
        {
          Playlist_Name: playlist?.name ?? '',
          Copy_To_Location: 'Channel',
          Copy: 'Channel',
          Type: 'Playlist',
          'Channel ID': parseInt(originGroupId),
        },
      ),
    )
    handleClose()
  }

  return (
    <>
      <DocumentHeadTags title="Copy to channel | DISCO" />
      <AddToChannelModal
        type="copy"
        groups={groups}
        source={playlist}
        onSubmit={handleAddToGroup}
        onClose={handleClose}
      />
    </>
  )
}

export default CopyToChannel
